import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { requests } from "../../../common/RestAPI";
import { base64Decoding, checkFormatAllow, clearSessionStorage } from "../../../common/util";
import ContentsProps from "../../../interfaceTypes/ContentsProps";
import { PAGE_URL, PLATFORM_URL } from "../../../value/Url";
import { SESSIONSTORAGE } from "value/staticValues";
import BasicPopupModal from "components/base/modal/BasicPopupModal";
import { View } from "react-native";
import MyInfoChangePwd from "./MyInfoChangePwd";


export default function MyInfoChangePwdContainer(props:ContentsProps) {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [infoText, setInfoText] = useState('');
    const [infoError, setInfoError] = useState(false);
    const [isCapsLockOn, setIsCapsLockOn] = useState(false);
    const [currentPwd, setCurrentPwd] = useState("");
    const [newPwd, setNewPwd] = useState("");
    const [newPwdCheck, setNewPwdCheck] = useState("");
    const [completePopupYn, setCompletePopupYn] = useState(false);


    useEffect(() => {
        window.addEventListener("keyup", detectCapsLock);
        return () => {
            window.removeEventListener("keyup", detectCapsLock);
        };
    }, [])


    useEffect(() => {
        if(isCapsLockOn) {
            AlertFunction(t('CASPLOCK_ON_ALERT'));
        }
        else {
            AlertFunction("");
        }
    }, [isCapsLockOn])


    function detectCapsLock(e: KeyboardEvent) {
        if (e.getModifierState("CapsLock")) {
            setIsCapsLockOn(true);
        } else {
            setIsCapsLockOn(false);
        }
    }


    function AlertFunction(text:string, error=false) {
        setInfoText(text);
        setInfoError(error);
    }


    function ChangePwdFunction() {
        AlertFunction("", false);

        if(!checkFormatAllow(newPwd, ["password"])) {
            AlertFunction(t("LOGIN_PASSWORD_INPUT_FORMAT_ERROR_MESSAGE"), true);
            return;
        } else if (newPwd !== newPwdCheck) {
            AlertFunction(t("PWD_NOT_MATCH_CHECK_ALERT_TEXT"), true);
            return;
        }

        const body = {
            current_password: currentPwd,
            new_password: newPwd
        }

        const userId = base64Decoding(sessionStorage.getItem(SESSIONSTORAGE.USER_ID));

        requests.put(PLATFORM_URL.USERS + '/' + userId + PLATFORM_URL.PWD_CHANGE, body)
        .then((response) => {
            if (response.status === 200) {
                setCompletePopupYn(true);
            }
        })
        .catch((error) => {
            if (error.status === 409) {
                AlertFunction(t("PWD_NOT_MATCH_CURRENT_PASSWORD"), true);
            } else {
                AlertFunction(t("PWD_NOT_MATCH_CHECK_ALERT_TEXT"), true);
            }
        })
    }


    function closePopupCb() {
        setCompletePopupYn(false);
        clearSessionStorage();
        navigate(`${PAGE_URL.LOGIN}`);
    }


    return (
        <View style={{flex: 1}}>
            <MyInfoChangePwd
            currentPwd={currentPwd}
            newPwd={newPwd}
            newPwdCheck={newPwdCheck}
            setCurrentPwd={setCurrentPwd}
            setNewPwd={setNewPwd}
            setNewPwdCheck={setNewPwdCheck}
            changePwdFn={ChangePwdFunction}
            infoText={infoText}
            infoError={infoError}
            navigate={navigate}
            />

            <BasicPopupModal
                showPopupYn={completePopupYn}
                desc={t('MY_INFO_DIALOG_CHANGE_PWD_COMPLATE_INFO_TEXT')}
                closeBtnCb={closePopupCb}
                confirmBtnCb={closePopupCb}
                confirmBtnText={t('CONFIRM_TEXT')}/>
        </View>

    )
}